// src/reducers/notificationReducer.js

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { vendorApi,investorApi } from "../api/api";

// Async: Fetch all notifications
export const fetchNotifications = createAsyncThunk(
  "notifications/fetchAll",
  async () => {
    const response = await vendorApi.getAllNotifications();
    return response.data.data || [];
  }
);

// Async: Delete single notification
export const deleteNotification = createAsyncThunk(
  "notifications/delete",
  async (id) => {
    await investorApi.deleteNotificationById(id);
    return id;
  }
);

// Async: Delete all notifications
export const deleteAllNotifications = createAsyncThunk(
  "notifications/deleteAll",
  async () => {
    await investorApi.deleteAllNotifications();
    return [];
  }
);

// Async: Mark all as read
export const markAllAsRead = createAsyncThunk(
  "notifications/markAllAsRead",
  async () => {
    const response = await investorApi.markAllNotificationsAsRead();
    return;
  }
);

export const markAsRead=createAsyncThunk(
    "notifications/markAsRead",
    async (id) => {
        await investorApi.markAsRead(id);
        return id;
    }
)

const notificationSlice = createSlice({
  name: "notifications",
  initialState: {
    list: [],
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchNotifications.fulfilled, (state, action) => {
        state.list = action.payload;
      })
      .addCase(deleteNotification.fulfilled, (state, action) => {
        state.list = state.list.filter((n) => n.Id !== action.payload);
      })
      .addCase(deleteAllNotifications.fulfilled, (state) => {
        state.list = [];
      })
      .addCase(markAllAsRead.fulfilled, (state) => {
        state.list = state.list.map((n) => ({
          ...n,
          Status: "Read",
        }));
      })
      .addCase(markAsRead.fulfilled, (state, action) => {
  const id = action.payload;
  const notification = state.list.find((n) => n.Id === id);
  if (notification) {
    notification.Status = "Read";
  }
});
      
  },

});

export default notificationSlice.reducer;
